import React from 'react';
import PropTypes from 'prop-types';
import {Tooltip} from 'reactstrap';

export function TooltipValidator(props) {
  const {checkActive, field, target} = props;

  const isOpen = !!(
    (field.meta.visited || !field.meta.pristine || field.meta.submitFailed) &&
    (checkActive ? field.meta.active : true) &&
    field.meta.invalid && field.meta.error
  );

  return <Tooltip
    placement={field.tooltipPlacement || 'top'}
    className="error"
    isOpen={isOpen}
    target={target}
  >
    {Array.isArray(field.meta.error) ?
      field.meta.error.map((e, key) => <div key={key}>{e}</div>) :
      <div>{field.meta.error}</div>
    }
  </Tooltip>;
}

TooltipValidator.propTypes = {
  checkActive: PropTypes.bool,
  field: PropTypes.object.isRequired,
  target: PropTypes.string.isRequired,
};

TooltipValidator.defaultProps = {
  checkActive: false
};

export default TooltipValidator;